import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { useCallback, useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

import { green, grey } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Divider, IconButton, Switch } from "@mui/material";
import PublishModal from "./PublishModal/PublishModal";
import { publishTableColumn, attributeCollectionTypes, selectedShootPagepath } from "components/PimDashboard/data";
import { converAttrToDatagridCol, createdByColumns, imageTableColumn, publishColumns, styleImageColumn } from "data/globalData";
import { FileDownloadRounded, FilterAltRounded, PlaylistAddRounded } from "@mui/icons-material";
import FileSaver from "file-saver";
import FilterModal from "./FilterModal/FilterModal";
import AddColumnModal from "./AddColumnModal/AddColumnModal";
import { allowAccess } from "utils/userAccessFun";
import { custom, departments } from "data/authData";
import { AuthState } from "context/AuthContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { lsModalProfileFilterValStr } from "./data";
import { shootUrlKey } from "../CreateShoot/data";
import _ from "lodash";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";
import { StudioDashboardState } from "context/StudioDashboardContext";
import moment from "moment";
import IconOnlyCalendarWithCountBadge from "components/PimDashboard/CommonComponents/DateBadgeCalendar/DateBadgeCalendar";
import dayjs from "dayjs";

export function setStylesCustomFun(prev, newRows) {
	const map = {};

	const result = [...prev, ...newRows]?.reduce((acc, row) => {
		if (map[row.shoot_id]) return acc;
		else {
			acc.push(row);
			map[row.shoot_id] = true;
		}
		return acc;
	}, []);
	return result;
}

const pageFilterLgKey = "shoots_table_attr";

const ShootsDashboard = () => {
	const gridRef = useRef();
	const { allAttributes, allAttributesObj } = StudioDashboardState();
	const { user } = AuthState();
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [tableData, setTableData] = useState([]);
	const [displayImg, setDisplayImg] = useState(true);
	const [selectedRowToPublish, setSelectedRowToPublish] = useState();
	const [tableStatusCount, setTableStatusCount] = useState({
		total: 0,
		pending: 0,
		published: 0,
	});
	const [publishModal, setPublishModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const [addColumnModal, setAddColumnModal] = useState(false);
	const [highlightedData, setHighlightedData] = useState({});
	const [open, setOpen] = useState(false);
	const iconRef = useRef(null);

	const defColumns = [
		// {
		// 	field: "color_count",
		// 	headerName: "Colors",
		// 	width: 80,
		// 	...colStyle,
		// },
		...createdByColumns.map((row) => converAttrToDatagridCol(row)),
	];

	const [dgTablColumns, setDgTableColumns] = useState(defColumns);

	const [attrColumns, setAttrColumns] = useState(() => {
		if (localStorage.getItem(pageFilterLgKey)) {
			return JSON.parse(localStorage.getItem(pageFilterLgKey))
				?.map((row) => {
					return { ...allAttributesObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row));
		} else
			return allAttributes
				?.filter((row) => row?.linked_table === studioAttrGroupLinkedTables.shoot.key)
				?.map((row) => converAttrToDatagridCol(row));
	});

	const [filterColumns, setFilterColumns] = useState(
		// appling filter fron local storage data
		() => {
			let final = [];
			if (localStorage.getItem(lsModalProfileFilterValStr)) {
				const localStorageObj =
					typeof JSON.parse(localStorage.getItem(lsModalProfileFilterValStr)) === "object"
						? JSON.parse(localStorage.getItem(lsModalProfileFilterValStr))
						: {};
				[...defColumns, ...allAttributes, ...Object.keys(publishColumns).map((row) => publishColumns[row])]?.forEach((row) => {
					if (localStorageObj?.[row?.key]) final.push(row);
				});
				return final;
			}
		}
	);
	const [filterColumnVal, setFilterColumnVal] = useState(() => {
		if (localStorage.getItem(lsModalProfileFilterValStr)) {
			return JSON.parse(localStorage.getItem(lsModalProfileFilterValStr));
		} else {
			return {};
		}
	});
	const [offset, setOffset] = useState(0);
	const [recordsLimit] = useState(20);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);

	const handleCloseFilterModal = () => {
		setFilterModal(false);
	};

	const handleCloseAddColumnModal = () => {
		setAddColumnModal(false);
	};

	const handleFilterClick = () => {
		setFilterModal(true);
	};

	const handleAddColumnClick = () => {
		setAddColumnModal(true);
	};

	const fetchtableData = async (offset, limit) => {
		try {
			const extraColumns = attrColumns?.reduce((acc, row) => {
				acc[row.field] = true;
				return acc;
			}, {});

			const { data } = await axios.post(`/api/studio/shoots/${offset}`, {
				filter: filterColumnVal,
				extraColumns,
				limit,
			});
			setTableData((prev) => setStylesCustomFun(prev, data?.result?.rows ?? []));
			setTableStatusCount(data.result.count[0]);
			setOffset((prev) => prev + recordsLimit);
			return data.result;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return null;
		}
	};
	const fetchShootsDateData = async (date = dayjs().format("YYYY-MM-DD")) => {
		const query = {
			date,
		};
		try {
			const { data } = await axios.get(`/api/studio/shoots_dates`, {
			params: query,
		});
			let dates = {
				...data.result.reduce((acc, row) => {

					acc[row.date] = row.count;
					return acc;
				}, {}),
			};
			setHighlightedData(dates);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return null;
		}
	};

	const loadMoreData = useCallback(
		_.throttle(async () => {
			if (loading || !hasMore) return;
			if (tableData?.length > 100) return;
			setLoading(true);

			const newRows = await fetchtableData(offset, recordsLimit);

			if (newRows?.rows?.length < recordsLimit) setHasMore(false);
			setLoading(false);
		}, 2000),
		[loading, hasMore, offset]
	);

	useEffect(() => {
		const gridElement = gridRef.current;
		if (!gridElement) return;
		const scrollContainer = gridElement.querySelector(".MuiDataGrid-virtualScroller");
		if (!scrollContainer) return;
		const handleScroll = () => {
			const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				loadMoreData();
			}
		};
		scrollContainer.addEventListener("scroll", handleScroll);
		return () => {
			scrollContainer.removeEventListener("scroll", handleScroll);
		};
	}, [loadMoreData]);

	useEffect(() => {
		const fetchInitialData = async () => {
			setLoadingOpen(true);
			setDgTableColumns([
				publishTableColumn(handlePublishClick, !allowAccess(custom.SHOOT_PUBLISHER.key, user, departments.STUDIO.key)),
				imageTableColumn(styleImageColumn),
				...attrColumns,
				...defColumns,
			]);
			const result = await fetchtableData(0, recordsLimit);
			if (result) {
				setTableData(result.rows);
				setTableStatusCount(result.count[0]);
				setOffset((prev) => prev + recordsLimit);
				setHasMore(result.rows.length === recordsLimit);
				setLoadingOpen(false);
			} else setLoadingOpen(false);
		};

		fetchInitialData();
	}, [filterColumns, attrColumns]);

	const navigate = useNavigate();

	const handleImageSwitchChange = (checked) => {
		setDisplayImg(checked);
	};

	const handleStyleSelect = async (data) => {
		navigate(`/${selectedShootPagepath}?${shootUrlKey}=${data.shoot_id}`);
	};
	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/studio/download_modal_profiles`,
				method: "POST",
				responseType: "blob",
				data: { filter: filterColumnVal },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `allStyles.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	const handlePublishClick = async (e, selectedRow) => {
		e.stopPropagation();
		setSelectedRowToPublish(selectedRow);
		setPublishModal(true);
	};
	const onPublishFinalSubmit = async (selectedRow) => {
		setLoadingOpen(true);

		try {
			const res = await axios.post(`/api/studio/publish_shoot`, {
				shoot_id: selectedRow.shoot_id,
				published_date: moment().format("YYYY-MM-DD"),
			});
			setTableData((prev) =>
				prev.map((tableRow) => {
					if (tableRow.shoot_id === selectedRow.shoot_id) {
						return { ...tableRow, ...res.data.result };
					} else return tableRow;
				})
			);
			setSelectedRowToPublish();
			setTableStatusCount((prev) => ({ ...prev, published: +prev.published + 1, pending: prev.pending - 1 }));
			setPublishModal(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Shoot Published Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Stack width="100%" pt={1}>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				{/* left section */}
				<Stack spacing={1} width="28%">
					<Box display="flex" columnGap={1} pt={1} flexWrap="wrap" alignItems="center" rowGap={"5px"}>
						<Button
							variant="contained"
							size="small"
							startIcon={<FilterAltRounded />}
							onClick={handleFilterClick}
							sx={{ textTransform: "capitalize" }}>
							Filter
						</Button>
						:
						{!filterColumns?.length && (
							<Typography variant="body1" fontSize={16} color={grey[700]}>
								None
							</Typography>
						)}
						{filterColumns?.map((row) => {
							return (
								<Chip
									label={`${row.name} : ${
										Array.isArray(filterColumnVal[row?.key])
											? filterColumnVal[row?.key]?.join(", ")
											: filterColumnVal?.[row?.key]
									}`}
									size="small"
								/>
							);
						})}
					</Box>
					<Box>
						<Button
							variant="contained"
							sx={{ textTransform: "capitalize", mr: 1 }}
							size="small"
							onClick={handleAddColumnClick}
							startIcon={<PlaylistAddRounded />}>
							Manage Columns
						</Button>
						<Button
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize" }}
							onClick={handleDownloadClick}
							startIcon={<FileDownloadRounded />}>
							Download
						</Button>
					</Box>
				</Stack>
				{/* right section */}
				<Box>
				 <IconButton ref={iconRef} onClick={() => setOpen(true)}>
					<CalendarMonthIcon />
				</IconButton>
					{open && <IconOnlyCalendarWithCountBadge value={dayjs()} highlightedData={highlightedData} apiCall = {(data) => fetchShootsDateData(data)} open={open} setOpen = {() => setOpen(!open)} iconRef={iconRef} />}
				</Box>
			</Box>
			<Box display="flex" justifyContent="space-between" alignItems="center" pt={1}>
				<Box display="flex" alignItems="center">
					<Typography variant="h6">Images</Typography>
					<Switch checked={displayImg} onChange={(e) => handleImageSwitchChange(e.target.checked)} sx={{ mt: 1 }} />
				</Box>
				<Box display="flex" alignItems="center" columnGap={1}>
					<Typography variant="body1">
						Total: <span style={{ color: grey[700] }}>{tableStatusCount.total}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1">
						Published: <span style={{ color: green[600] }}>{tableStatusCount.published}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1" fontWeight={600}>
						Pending: <span style={{ color: "red" }}>{tableStatusCount.pending}</span>
					</Typography>
				</Box>
			</Box>

			<Box height="60vh" ref={gridRef}>
				<DataGrid
					rows={tableData ? tableData : []}
					key={displayImg}
					columns={dgTablColumns ?? []}
					sx={{
						// minWidth: "100%"
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={displayImg ? 70 : 40}
					getRowId={(row) => row?.shoot_id}
					onRowClick={(params, e) => handleStyleSelect(params.row)}
					initialState={{
						columns: {
							columnVisibilityModel: {
								[styleImageColumn.key]: displayImg,
							},
						},
					}}
					disableRowSelectionOnClick
					hideFooter={true}
					pagination={false}
					disableColumnFilter
					disableColumnSelector
					disableAutosize
				/>
				{/* <Box sx={{ minHeight: "20px" }}> */}
				{loading && (
					<Box display="flex" sx={{ background: grey[400], borderRadius: 2, p: 1 }} alignItems="center">
						<Typography variant="body2" color={grey[900]}>
							Loading...
						</Typography>
						<CircularProgress size="18px" sx={{ transform: "scale(0.4)" }} />
					</Box>
				)}
			</Box>

			<PublishModal
				modal={publishModal}
				setModal={setPublishModal}
				selectedRow={selectedRowToPublish}
				setSelectedRow={setSelectedRowToPublish}
				submitFunction={onPublishFinalSubmit}
			/>
			<FilterModal
				modal={filterModal}
				handleCloseModal={handleCloseFilterModal}
				filterColumns={filterColumns}
				setFilterColumns={setFilterColumns}
				filterColumnVal={filterColumnVal}
				setFilterColumnVal={setFilterColumnVal}
				localStorageStr={lsModalProfileFilterValStr}
				collection={attributeCollectionTypes.SHOOTS}
			/>
			<AddColumnModal
				modal={addColumnModal}
				handleCloseModal={handleCloseAddColumnModal}
				attrColumns={attrColumns}
				setAttrColumns={setAttrColumns}
				localStorageStr={pageFilterLgKey}
				collection={attributeCollectionTypes.SHOOTS}
			/>
		</Stack>
	);
};

export default ShootsDashboard;
